import { all, call, put, select, takeLatest } from "redux-saga/effects";
import {
  updateRecruitmentFailed,
  updateRecruitmentStart,
  updateRecruitmentSuccess,
} from "../redux/updateRecruitment";
import { formInputRecruitmentSelector } from "../redux/selector";
import { updateRecruitmentRqApi } from "core/http/service/recruitment";
import {
  getListRecruitmentRequirementStart,
  resetListRecruitmentRequirement,
} from "../redux/getListRecruitmentRequirement";
import { toast } from "react-toastify";
import { formRecruitmentReset } from "../redux/formInput";
import { resetControlPage } from "components/common/ListInfinitiveScrolling/redux/controlInfinitiveScrolling";

function* updateRecruitmentWork(action) {
  const { callBack } = action.payload;

  const formData = yield select(formInputRecruitmentSelector);

  try {
    const newForm = {
      ...formData,
      departmentCode:
        formData?.departmentLevel3Code ||
        formData?.departmentLevel2Code ||
        formData?.departmentLevel1Code,
      filePath: JSON.stringify(formData?.files),
      specializedCode: formData?.specializedCode?.map((it) => it?.value),
      practiceCertificateCode: formData?.practiceCertificateCode?.map(
        (it) => it?.value
      ),
      languageLevelCode: formData?.languageLevelCode?.map((it) => it?.value),
      relatePerson:
        (formData?.relatePerson || []).length > 0
          ? formData?.relatePerson.map((it) => it?.value).join(",")
          : ``,
    };
    const res = yield call(updateRecruitmentRqApi, newForm);
    if (res) {
      yield put({
        type: updateRecruitmentSuccess.type,
      });

      yield put({
        type: resetListRecruitmentRequirement.type,
      });

      yield put({
        type: formRecruitmentReset.type,
      });
      yield put({
        type: resetControlPage.type,
        payload: "recruitmentRequirement",
      });
      yield put({
        type: getListRecruitmentRequirementStart.type,
      });

      callBack?.();

      toast.success("Cập nhật yêu cầu tuyển dụng thành công!");
    }
  } catch (error) {
    yield put({
      type: updateRecruitmentFailed.type,
    });
    toast.error(
      error?.response?.data?.message || "Đã có lỗi xảy ra lúc tạo đơn!"
    );
  }
}

function* watchUpdateRecruitment() {
  yield takeLatest(updateRecruitmentStart.type, updateRecruitmentWork);
}

export default function* updateRecruitmentSaga() {
  yield all([watchUpdateRecruitment()]);
}
